import { Injectable } from '@angular/core';

import { APP_DATA_KEYS } from '../constants/app-data.constants';

import { MaatSorDescriptionSet } from '../interfaces/maat-sor-description-set.interface';

import { MaatSorCodeParser } from '../helpers/maat-sor-code-parser';

import { AppDataService } from './app-data.service';

@Injectable({
  providedIn: 'root'
})
export class MaatSorDescriptionService {

  constructor(
    private appDataService: AppDataService) {
  }

  getMaatSorDescriptionSet(): MaatSorDescriptionSet {
    return this.appDataService.getAppData<MaatSorDescriptionSet>(APP_DATA_KEYS.maatSorDescriptionSet);
  }

  getMaatSorDescription(sorCode: string): string {
    const sorCodeSuffix = MaatSorCodeParser.extractSuffix(sorCode);
    return sorCodeSuffix && this.getMaatSorDescriptionSet()?.[sorCodeSuffix];
  }
}
